import { axios } from '@/lib/axios'
import { useQuery } from '@tanstack/react-query'
import { Testimonial } from '../types'

const getTestimonials = (): Promise<Testimonial[]> => {
  return axios.get('/testimonial')
}
export const useTestimonials = () => {
  return useQuery({
    queryFn: getTestimonials,
    queryKey: ['testimonial'],
  })
}
